import Layout from "@/components/Layout";
import TeamInbox from "@/components/TeamInbox";

export default function Messages() {
  return (
    <Layout title="Messages" subtitle="Admin Inbox">
      <TeamInbox department="Admin" title="Admin — Landlord Messages" />
    </Layout>
  );
}
